import { format } from '#shared/lib/string';

export type GetPromoactionValidUntilTextParams = {
    deactivated?: boolean;
    status?: 'active' | 'inactive';
    validUntil?: string;
};

export const getPromoactionValidUntilText = (
    params: GetPromoactionValidUntilTextParams,
    isRelative: boolean = true
): string => {
    const { deactivated, status, validUntil } = params;

    if (isRelative && (deactivated || status === 'inactive')) {
        return '';
    }

    if (validUntil) {
        return `${isRelative ? 'По ' : ''}${format(validUntil, 'date', { invalidValue: 'значение_неизвестно' })}`;
    }

    return isRelative ? 'Бессрочно' : 'Бессрочный';
};
